<template>
  <div>
    <div class="makbuz">
      <div class="header" v-html="data.Bilgi.Makbuz"></div>
      <hr v-if="data.Bilgi.Makbuz">
      <div class="Detay">
        <p style="font-size: 14px;font-weight: bold">{{data.Bilgi.BinaAdi}} adına {{data.Bilgi.oTarihi}} tarihinde
          {{data.Bilgi.Kasa}} kasasına <br>{{data.Bilgi.OdemeTutar}} TL devir alınmıştır.</p>
        <em v-if="data.Bilgi.Aciklama"><b>Makbuz Açıklama:</b> {{data.Bilgi.Aciklama}}</em>
      </div>
      <div class="Bilgi">
        <table class="table">
          <thead>
          <tr>
            <th colspan="2" class="text-center">{{data.Bilgi.TurText}}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>Bina Adı</td>
            <td class="text-right">{{data.Bilgi.BinaAdi}}</td>
          </tr>
          <tr>
            <td>Makbuz No</td>
            <td class="text-right">{{data.Bilgi.mNo}}</td>
          </tr>
          <tr>
            <td>Kasa</td>
            <td class="text-right">{{data.Bilgi.Kasa}}</td>
          </tr>
          <tr>
            <td>Ödeme Tarihi</td>
            <td class="text-right">{{data.Bilgi.oTarihi}}</td>
          </tr>
          <tr>
            <td>İşlem Zamanı</td>
            <td class="text-right">{{data.Bilgi.iTarihi}}</td>
          </tr>
          <tr>
            <td>Ödenen</td>
            <td class="text-right"><b>{{data.Bilgi.OdemeTutar}} TL</b></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="makbuzaltimza float-left">
        <b>Teslim Eden</b><br>
        <small>Adı Soyad<br>İmza</small>
      </div>
      <div class="makbuzaltimza float-right">
        <b>Teslim Alan</b><br>
        <small>{{data.Bilgi.Personel.AdSoyad}}<br>İmza</small>
      </div>
    </div>
    <div class="clearfix"></div>
    <hr>
    <div slot="footer" v-if="!IptalMakbuzu" class="dialog-footer text-center">

      <el-button v-if="this.$store.getters.Yetki.MakbuzIptal>0" type="danger" class="float-left" size="medium"
                 @click="IptalEt()" icon="el-icon-check">
        İptal Et
      </el-button>
      <el-button type="primary" class="float-right" size="medium" @click="Yazdir()" icon="el-icon-check">
        Yazdır
      </el-button>
      <div class="clearfix"></div>
    </div>
    <DevirYazdir @close="Yazdirma=false" v-if="Yazdirma" :data="data"></DevirYazdir>
  </div>
</template>

<script>

  import DevirYazdir from "../../../Yazdir/DevirYazdir";
  export default {
    components: {DevirYazdir},
    props: ['data','IptalMakbuzu'],
    data() {
      return {
        IptalYetki: null,
        lo: true,
        Yazdirma: false,
      }
    },
    methods: {
      Yazdir() {
        this.Yazdirma = true;
      },
      IptalEt() {

        this.$confirm("Makbuzu iptal etmek istediğinize eminmisiniz?", this.$t('eGenel.7'), {
          confirmButtonText: this.$t('eGenel.2'),
          cancelButtonText: this.$t('eGenel.3'),
          type: 'warning'
        }).then(() => {
          this.Sil()
        }).catch(() => {
          this.$message.info(this.$t('eGenel.8'));
        });
      },
      Sil() {
        this.lo = true
        this.$store.dispatch("Delete", {...this.Form, path: 'MakbuzIptal/' + this.data.Bilgi.id})
          .then(response => {
            if (response.Durum == "OK") {
              this.$emit('MakbuzDetayModal', false);
              this.$message.success(response.Mesaj);
              this.lo = false
              this.SayfaYukle();
            } else {
              this.$message.warning(response.Mesaj);
              this.hata = response.Hata;
              this.lo = false
            }
          })

      },

    },
    created() {
      this.SayfaYukle();
      this.IptalYetki = this.$store.getters.Yetki.iptal;
    }
  }
</script>

<style scoped>
  .makbuzaltimza {
    width: 5cm;
    padding: 10px;
    border: 1px dashed #ccc;
    text-align: center;
    margin-top: 10px;
    height: 3cm;
  }

  .makbuzaltimza b {
  }

  .makbuzaltimza small {
    opacity: 0.5;
    line-height: 10px;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pack/Vezne/Makbuz/Devir.vue